/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_FolderInputs */

const en_common_folder = /** @type {(inputs: Common_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folder`)
};

const es_common_folder = /** @type {(inputs: Common_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carpeta`)
};

/**
* | output |
* | --- |
* | "Folder" |
*
* @param {Common_FolderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_folder = /** @type {((inputs?: Common_FolderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_FolderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_folder(inputs)
	return en_common_folder(inputs)
});